var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-items-center justify-content-between w-100" },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Use this id as the option value to select this style",
                },
                expression:
                  "{ content: 'Use this id as the option value to select this style' }",
              },
            ],
            staticClass: "style-id",
          },
          [_vm._v("\n            " + _vm._s(_vm.item.id) + ".\n        ")]
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "style-icon mr-2",
          attrs: { src: _setup.icon, alt: "" },
          on: {
            error: function ($event) {
              _setup.thumbnailFailed = true
            },
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.item.name))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions d-flex", class: { visible: _vm.selected } },
        [
          _c(_setup.CButton, {
            attrs: {
              size: "icon",
              icon: ["far", "pen"],
              disabled: _vm.disabled,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _setup.emit("edit", _vm.item)
              },
            },
          }),
          _vm._v(" "),
          _c(_setup.CButton, {
            attrs: {
              size: "icon",
              icon: ["far", "trash-can"],
              disabled: _vm.disabled,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _setup.emit("remove", _vm.item)
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }